var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('iframe',{key:_vm.url,staticClass:"my-auto mx-auto",attrs:{"src":_vm.url,"frameborder":"0","scrolling":"no","title":"Graceway Radio Donation Form"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }